// models/metrics/metasearchMetrics/wego/wegoMetrics.js

// conversion
import MetricBookingcountWego from "models/metrics/metasearchMetrics/wego/conversion/MetricBookingcount";
import MetricConversionWego from "models/metrics/metasearchMetrics/wego/conversion/MetricConversion";
import MetricRevenuePerclickWego from "models/metrics/metasearchMetrics/wego/conversion/MetricRevenuePerclick";
import MetricRoiWego from "models/metrics/metasearchMetrics/wego/performance/MetricRoi";

// performance
import MetricClicksWego from "models/metrics/metasearchMetrics/wego/performance/MetricClicks";
import MetricCpcWego from "models/metrics/metasearchMetrics/wego/performance/MetricCpc";
import MetricCsrWego from "models/metrics/metasearchMetrics/wego/performance/MetricCsr";
import MetricGeneratedWego from "models/metrics/metasearchMetrics/wego/performance/MetricGenerated";
import MetricSpentWego from "models/metrics/metasearchMetrics/wego/performance/MetricSpent";

const wegoMetrics = [
    // conversion
    new MetricBookingcountWego(),
    new MetricConversionWego(),
    new MetricRevenuePerclickWego(),
    new MetricRoiWego(),
    // performance
    new MetricClicksWego(),
    new MetricCpcWego(),
    new MetricCsrWego(),
    new MetricGeneratedWego(),
    new MetricSpentWego(),
];

export function findMetricById(metricId) {
    return wegoMetrics.find((metricClass) => metricClass.field === metricId);
}

export default wegoMetrics;
